module.exports = __webpack_public_path__ + "img/sample-07.711663b0.jpg";